<template>
  <v-dialog 
    v-model="navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialogIsVisible" 
    @update:model-value="navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialogIsVisible == false ? closeSendCRMWhatsappMessageToCRMWhatsappContactDialog() : null" 
    :max-width="$vuetify.display.mobile ? '90vw' : '80vw'"
    style="user-select: none; cursor: default;"
  >
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">{{ navigation.generateCRMWhatsappContactFollowup ? 'mdi-source-branch-plus' : 'mdi-chat-plus' }}</v-icon>
            <h3>{{ navigation.generateCRMWhatsappContactFollowup ? 'GENERAR SEGUIMIENTO' : 'INICIAR CONVERSACIÓN' }}</h3>
          </div>
          <div class="actionsContainer">
            <v-btn 
              @click="closeSendCRMWhatsappMessageToCRMWhatsappContactDialog()"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>
      <div style="flex: 1; overflow-y: auto;">
        <div v-if="display.CRMWhatsappConversation" class="dataContainer">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-barcode</v-icon>
              <p><strong>ID: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappContactID || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-card-account-details</v-icon>
              <p><strong>SSN: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappContactSSN || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-account</v-icon>
              <p><strong>Nombre: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappConversation) }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-phone</v-icon>
              <p><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(display.CRMWhatsappConversation.CRMWhatsappContactPhoneNumber) }}</p>
            </div>
          </div>
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-email</v-icon>
              <p><strong>Correo electrónico: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappContactEmail || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-store</v-icon>
              <p style="margin-right: 5px;"><strong>Localidad: </strong></p>
              <template v-if="display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID && systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID)">
                <v-chip :color="systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                  <p>{{ systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                </v-chip>
              </template>
              <template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <p>No registrada</p>
                </v-chip>
              </template>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-calendar-start</v-icon>
              <p><strong>Primera orden: </strong>{{ display.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-calendar-end</v-icon>
              <p><strong>Última orden: </strong>{{ display.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
            </div>
          </div>
        </div>
        <v-card color="borderInner" elevation="0" rounded="0" style="width: 100%; height: 1px;"></v-card>
        <template v-if="display.CRMWhatsappConversation && display.CRMWhatsappConversation.CRMWhatsappConversationID">
          <div style="display: flex; align-items: center; gap: 10px; padding: 15px; margin-top: 5px;">
            <p>La conversación <strong>{{ display.CRMWhatsappConversation.CRMWhatsappConversationID }}</strong> con el contacto <strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappConversation) }}</strong> está activa en este momento con el agente
              <span>
                <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>No registrado</p>
                    </div>
                  </v-chip>
                </template>
              </span>
              . Es necesario transferirla o cerrarla antes de iniciar la conversación por este medio
            </p>
          </div>
        </template>
        <template v-else>
          <div style="padding: 15px;">
            <template v-if="input.CRMWhatsappTextMessageContent">
              <div style="display: flex; justify-content: flex-end;">
                <v-card rounded="lg" :color="systemInformationData?.CRMAgent?.CRMAgentOwnMessageColor || 'primary'" style="width: 75%; padding: 10px 15px; word-break: break-word; display: inline-block; clear: both; position: relative;">
                  <p style="margin: 0; color: #303030; font-size: 16px; line-height: 1.4; white-space: pre-wrap; word-wrap: break-word; font-weight: bold;">Hola, te escribimos de parte de King Ventas!</p>
                  <p style="margin: 0; color: #303030; font-size: 14px; line-height: 1.4; white-space: pre-wrap; word-wrap: break-word; margin-top: 10px;">{{ input.CRMWhatsappTextMessageContent }}</p>
                  <p style="margin: 4px 0 0 0; font-size: 12px; color: #666; margin-top: 10px;">Por favor contesta este mensaje (por ejemplo, con un "hola) o presiona el botón para que nuestros agentes puedan continuar con el chat</p>
                  <v-divider style="margin-top: 20px;"></v-divider>
                  <v-btn readonly color="primary" variant="tonal" block style="margin-top: 20px;">
                    <v-icon style="margin-right: 10px;">mdi-reply-outline</v-icon>
                    <h3>CONTINUAR CON EL CHAT</h3>
                  </v-btn>
                </v-card>
              </div>
              <br>
            </template>
            <v-autocomplete 
              v-if="systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMAgent/CRMAgentTemplateMessages')?.CRMAgentPermissionValue == '1'"
              ref="CRMAgentTemplateMessageID"
              v-model="input.CRMAgentTemplateMessageID"
              v-model:search="input.CRMAgentTemplateMessageSearch"
              :items="systemInformationData.CRMAgent.CRMAgentTemplateMessages" 
              @update:model-value="input.CRMWhatsappTextMessageContent = systemInformationData.CRMAgent.CRMAgentTemplateMessages.find(CRMAgentTemplateMessage => CRMAgentTemplateMessage.CRMAgentTemplateMessageID == input.CRMAgentTemplateMessageID) ? systemInformationData.CRMAgent.CRMAgentTemplateMessages.find(CRMAgentTemplateMessage => CRMAgentTemplateMessage.CRMAgentTemplateMessageID == input.CRMAgentTemplateMessageID).CRMAgentTemplateMessageContent : null; $generalFunctions.default.focusInput(this, 'CRMWhatsappTextMessageContent');"
              :no-data-text="input.CRMAgentTemplateMessageSearch ? `No existe ningún mensaje de plantilla con el nombre '${input.CRMAgentTemplateMessageSearch}'` : 'Aún no se ha creado ningún mensaje de plantilla'"
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog"
              prepend-inner-icon="mdi-message-bookmark"
              item-title="CRMAgentTemplateMessageName" 
              item-value="CRMAgentTemplateMessageID" 
              label="Mensaje de plantilla (opcional)" 
              variant="outlined"
              density="compact"
              autocomplete="off"
              clearable
              hide-details
              style="margin-bottom: 15px;"
            >
              <template v-slot:item="{ props, item }">
                <v-list-item v-bind="props" style="margin: 0;">
                  <v-list-item-subtitle style="font-size: small;">{{ item.raw.CRMAgentTemplateMessageContent }}</v-list-item-subtitle>
                </v-list-item>
              </template>
            </v-autocomplete>
            <v-textarea
              ref="CRMWhatsappTextMessageContent"
              v-model="input.CRMWhatsappTextMessageContent"
              @update:model-value="handleCRMWhatsappTextMessageContentUpdate()" 
              :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog"
              :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog"
              prepend-inner-icon="mdi-text-box"
              label="Contenido del mensaje"
              variant="outlined"
              density="compact"
              autocomplete="off"
              rows="3"
              max-rows="5"
              clearable
              auto-grow
              hide-details
            ></v-textarea>
            <template v-if="navigation.generateCRMWhatsappContactFollowup">
              <v-textarea
                ref="CRMWhatsappContactFollowupNote"
                v-model="input.CRMWhatsappContactFollowupNote"
                :prepend-inner-icon="input.CRMWhatsappContactFollowupNote ? 'mdi-note-remove' : 'mdi-note'"
                @click:prepend-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFollowupNote'); input.CRMWhatsappContactFollowupNote = null"
                :loading="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog"
                :disabled="loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog"
                label="Nota del seguimiento (opcional)"
                variant="solo-filled"
                density="compact"
                autocomplete="off"
                rows="3"
                max-rows="5"
                auto-grow
                hide-details
                style="margin-top: 15px;"
              ></v-textarea>
            </template>
          </div>
          <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
          <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
            <v-tooltip :disabled="validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog(false).success" :text="validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog(false).result" location="top"> 
              <template v-slot:activator="{ props }">
                <div v-bind="props">
                  <v-btn 
                    @click="validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog(true).success ? sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog() : null" 
                    :disabled="!validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog(false).success || loader.getSystemInformationData || loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog || loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog" 
                    color="indigo"
                    block
                    class="hoverableText"
                  >
                    <v-icon style="margin-right: 10px;">{{ navigation.generateCRMWhatsappContactFollowup ? 'mdi-source-branch-plus' : 'mdi-chat-plus' }}</v-icon>
                    <h3>{{ navigation.generateCRMWhatsappContactFollowup ? 'GENERAR SEGUIMIENTO' : 'INICIAR CONVERSACIÓN' }}</h3>
                  </v-btn>
                </div>
              </template>
              <span style="max-width: 400px; display: block;">{{ validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog(false).result }}</span>
            </v-tooltip>
          </v-card>
        </template>
      </div>
    </v-card>
  </v-dialog>

</template>
  
<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  
  .titleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .dataContainer {
    padding: 15px;
    gap: 10px;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(2, 1fr);
  }


  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }

    .titleContainer {
      justify-content: center;
    }

    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }

    .dataContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: {},
    data: () => 
    ({
      input: 
      {
        CRMAgentTemplateMessageID: null,
        CRMAgentTemplateMessageSearch: null,
        CRMWhatsappTextMessageContent: null,
        CRMWhatsappContactFollowupNote: null
      },
      display: 
      {
        CRMWhatsappConversation: null,
      },
      navigation: 
      {
        CRMWhatsappContactID: null,
        sendCRMWhatsappMessageToCRMWhatsappContactDialogIsVisible: false,
        generateCRMWhatsappContactFollowup: false
      },
      loader: 
      {
        getSystemInformationData: false,
        selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog: false,
        sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: null,
        CRMLocalities: null,
        tooltipDisabled: false,
        updateSubscription: null
      },
    }),
    
    methods:
    {

      async sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog(){
        this.loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog = true;
        const sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialogRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,  
          },
          'CRMWhatsappContactPhoneNumber': this.display.CRMWhatsappConversation.CRMWhatsappContactPhoneNumber,
          'CRMWhatsappTextMessageContent': this.input.CRMWhatsappTextMessageContent,
          'generateCRMWhatsappContactFollowup': this.navigation.generateCRMWhatsappContactFollowup,
          'CRMWhatsappContactFollowupNote': this.input.CRMWhatsappContactFollowupNote
        };
        const sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog', sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialogRequestQuery);
        if (sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialogResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog_success', 'success', this.navigation.generateCRMWhatsappContactFollowup ? `Se ha generado el seguimiento para el contacto ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.display.CRMWhatsappConversation)}` : `Se ha enviado el mensaje al contacto ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.display.CRMWhatsappConversation)}`, null, true);
          this.closeSendCRMWhatsappMessageToCRMWhatsappContactDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog_error', 'error', `Ha ocurrido un error inesperado al ${this.navigation.generateCRMWhatsappContactFollowup ? 'generar el seguimiento' : 'enviar el mensaje'} al contacto ${this.$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(this.display.CRMWhatsappConversation)}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog = false;
      },

      async selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog(){
        this.loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog = true;
        const selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialogRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID
        };
        const selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/functions/selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog', selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialogRequestQuery);
        if (selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialogResult.success){
          this.display.CRMWhatsappConversation = selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialogResult.result;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog_error', 'error', `Ha ocurrido un error inesperado al seleccionar la información del contacto ${this.navigation.CRMWhatsappContactID}, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, false);
          this.closeSendCRMWhatsappMessageToCRMWhatsappContactDialog();
        }
        this.loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog = false;
      },

      handleCRMWhatsappTextMessageContentUpdate(){
        if (this.input.CRMWhatsappTextMessageContent && this.input.CRMWhatsappTextMessageContent.includes('@')){
          if (this.display.CRMWhatsappConversation && this.display.CRMWhatsappConversation.CRMWhatsappContactFirstName){
            this.input.CRMWhatsappTextMessageContent = this.input.CRMWhatsappTextMessageContent.replace('@', this.display.CRMWhatsappConversation.CRMWhatsappContactFirstName);
          }
        }
      },
      
      validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.input.CRMWhatsappTextMessageContent == null || !regularExpressionChecker.test(this.input.CRMWhatsappTextMessageContent)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog_missingCRMWhatsappTextMessageContent', 'warning', 'El contenido del mensaje es obligatorio', null, false);
          return {success: false, result: 'El contenido del mensaje es obligatorio'};
        } else if (this.input.CRMWhatsappTextMessageContent.length < 20){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog_CRMWhatsappTextMessageContentTooShort', 'warning', 'El contenido del mensaje debe tener al menos 2 caracteres', null, false);
          return {success: false, result: 'El contenido del mensaje debe tener al menos 20 caracteres'};
        } else if (this.input.CRMWhatsappTextMessageContent.length > 1000){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForSendCRMWhatsappMessageToCRMWhatsappContactDialog_CRMWhatsappTextMessageContentTooLong', 'warning', 'El contenido del mensaje no puede exceder los 1000 caracteres', null, false);
          return {success: false, result: 'El contenido del mensaje no puede exceder los 1000 caracteres'};
        } 
        return {success: true, result: null};
      },

      async getSystemInformationData(){
        try {
          this.loader.getSystemInformationData = true;
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialogIsVisible = false;
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialogIsVisible = false;
        }
      },
      
      async openSendCRMWhatsappMessageToCRMWhatsappContactDialog(CRMWhatsappContactID, generateCRMWhatsappContactFollowup){
        await this.getSystemInformationData();
        this.input.CRMAgentTemplateMessageID = null;
        this.input.CRMAgentTemplateMessageSearch = null;
        this.input.CRMWhatsappTextMessageContent = null;
        this.input.CRMWhatsappContactFollowupNote = null;
        this.display.CRMWhatsappConversation = null;
        this.loader.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog = false;
        this.loader.sendCRMWhatsappMessageFromSendCRMWhatsappMessageToCRMWhatsappContactDialog = false;
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.generateCRMWhatsappContactFollowup = generateCRMWhatsappContactFollowup;
        this.navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialogIsVisible = true;
        this.selectCRMWhatsappConversationFromSendCRMWhatsappMessageToCRMWhatsappContactDialog();
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappTextMessageContent');
      },

      closeSendCRMWhatsappMessageToCRMWhatsappContactDialog(){
        this.navigation.sendCRMWhatsappMessageToCRMWhatsappContactDialogIsVisible = false;
        this.$emit('closeSendCRMWhatsappMessageToCRMWhatsappContactDialog');
      }
    }
  }
</script>